// Example request body for Discover Images v2 taken from:
// https://code.amazon.com/packages/AlexaMultimediaDiscoveryService/blobs/mainline/--/data/v2/discover/images/request-with-query-and-entities.json
const requestBodyTemplate = {
    "query_text": "obama in a late night show",
    "response_dimensions": {
        "size": "5"
    },
    "request_metadata": {
        "locale": "en-US",
        "profile": "WBR_AGILT"
    }
};

export const exampleDiscoverImagesV2RequestBody = JSON.stringify(requestBodyTemplate, null, 2);
export const getDiscoverImagesV2RequestBody = (query_text, result_size = "100") => {
    let requestBody = JSON.parse(JSON.stringify(requestBodyTemplate));
    requestBody.response_dimensions.size = result_size;
    requestBody.query_text = query_text;
    return JSON.stringify(requestBody, null, 2);
}

export const getDiscoverVideosRequestBody = (query_text, result_size = "20") => {
    let requestBody = JSON.parse(JSON.stringify(requestBodyTemplate));
    requestBody.response_dimensions.size = result_size;
    requestBody.query_text = query_text;
    requestBody['modality'] = 'VIDEO';
    return JSON.stringify(requestBody, null, 2);
}

export const getDiscoverImagesV2RequestWithGroundingBody = (query_text, grounded_answer, result_size = "100") => {
    let requestBody = JSON.parse(JSON.stringify(requestBodyTemplate));
    requestBody.response_dimensions.size = result_size;
    requestBody.query_text = grounded_answer;
    requestBody.query_metadata = {
        "grounding_query": query_text,
        "answer": grounded_answer
    }
    return JSON.stringify(requestBody, null, 2);
}

export const getDiscoverVideosRequestWithGroundingBody = (query_text, grounded_answer, result_size = "20") => {
    let requestBody = JSON.parse(JSON.stringify(requestBodyTemplate));
    requestBody.response_dimensions.size = result_size;
    requestBody.query_text = grounded_answer;
    requestBody['modality'] = 'VIDEO';
    requestBody.query_metadata = {
        "grounding_query": query_text,
        "answer": grounded_answer
    }
    return JSON.stringify(requestBody, null, 2);
}
    